import { Text } from '@thanx/uikit/text'
import { useStyletron } from '@thanx/uikit/theme'
import MultiUseIcon from 'assets/images/redeem-manager/multi-use-icon.svg'
import { buildTranslate } from 'locales'
import React from 'react'

export default ({ className = '' }: { className?: string }) => {
  const t = buildTranslate('redeem_manager.landing.redeem_item')
  const [css] = useStyletron()
  return (
    <div
      className={`white-bkg border grey-20-border inline-block py-xxs px-xs ${css(
        {
          borderRadius: '4px',
        }
      )} ${className}`}
    >
      <Text.SmallCaps3 bold color="grey70" tag="p" className="m-0 d-flex">
        <img src={MultiUseIcon} className="mr-xxs" alt="" />
        {t('multi_use')}
      </Text.SmallCaps3>
    </div>
  )
}
